import React from "react";
import { CurrentBonuses } from "../interfaces/BonusSourceDetails";
import { RuleItem } from "../interfaces/RuleItem";

const currentBonuses: CurrentBonuses = {};
const ruleItems: RuleItem[] = [];

export const BonusBreakdownContext = React.createContext({
  currentBonuses,
  ruleItems,
});
